import { CSSProperties, ReactNode } from "react";
import { isTextEllipsed } from "../../utils/general_utils";
import { Tooltip } from "@mui/material";

export const ReuseTooltip = ({
  text,
  children,
  style,
  hideChildren = true,
  placement = "top",
  maxWidth,
}: {
  text: ReactNode;
  children: ReactNode;
  style?: CSSProperties;
  hideChildren?: boolean;
  placement?: "bottom" | "top";
  maxWidth?: string;
}) => {
  if (!text && hideChildren) return null;
  return (
    <Tooltip
      title={text}
      placement={placement}
      arrow
      onMouseEnter={(e) => e.stopPropagation()}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth,
          },
        },
      }}
    >
      <span
        style={style}
        onMouseEnter={(event: React.MouseEvent<HTMLDivElement>) => {
          isTextEllipsed(event.currentTarget);
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
